"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.strace = exports.trace = exports.logSpanError = exports.withSpan = exports.getCurrentSpan = exports.TAG = void 0;
const micro_errors = __importStar(require("@journeyapps-platform/micro-errors"));
const opentelemetry = __importStar(require("@opentelemetry/api"));
const _ = __importStar(require("lodash"));
var TAG;
(function (TAG) {
    TAG["HTTP_METHOD"] = "http.method";
    TAG["HTTP_STATUS_CODE"] = "http.status_code";
    TAG["HTTP_URL"] = "http.url";
    TAG["ERROR"] = "error";
})(TAG || (exports.TAG = TAG = {}));
const tracer = opentelemetry.trace.getTracer('micro-tracing');
const getCurrentSpan = () => {
    return opentelemetry.trace.getActiveSpan();
};
exports.getCurrentSpan = getCurrentSpan;
const withSpan = (span, handler) => {
    const context = opentelemetry.trace.setSpan(opentelemetry.context.active(), span);
    return opentelemetry.context.with(context, handler);
};
exports.withSpan = withSpan;
const logSpanError = (error, span) => {
    const working_span = span ?? (0, exports.getCurrentSpan)();
    if (!working_span) {
        return;
    }
    working_span.setAttribute(TAG.ERROR, true);
    const error_data = micro_errors.getErrorData(error);
    if (error_data) {
        working_span.setAttributes(_.pickBy({
            'error.code': error_data.code,
            'error.status': error_data.status,
            'error.origin': error_data.origin
        }, _.identity));
    }
    working_span.addEvent('Error Details', {
        description: error_data?.description ?? '',
        details: error_data?.details ?? ''
    });
    working_span.recordException(error);
};
exports.logSpanError = logSpanError;
/**
 * Utility for propagating trace context through the call-stack and ensuring that errors are handled
 * and spans are properly ended
 *
 * Can provide either the name of a span (in which case it will be automatically created) or a
 * manually created span (which will only have it's lifecycle managed).
 *
 * Handles both synchronous and asynchronous (Promise) return values
 */
const trace = (name_or_span, handler) => {
    let span;
    if (typeof name_or_span === 'string') {
        span = tracer.startSpan(name_or_span, {
            kind: opentelemetry.SpanKind.INTERNAL
        });
    }
    else {
        span = name_or_span;
    }
    return (0, exports.withSpan)(span, () => {
        let is_promise = false;
        try {
            const res = handler(span);
            // If the response is a function then we only end the span once the function
            // resolves or throws
            if (res instanceof Promise) {
                is_promise = true;
                return res
                    .catch((err) => {
                    (0, exports.logSpanError)(err, span);
                    throw err;
                })
                    .finally(() => {
                    span.end();
                });
            }
            return res;
        }
        catch (err) {
            (0, exports.logSpanError)(err, span);
            throw err;
        }
        finally {
            if (!is_promise) {
                span.end();
            }
        }
    });
};
exports.trace = trace;
/**
 * Attach a span to the lifespan of a stream. This will end the span when the stream ends and log a span
 * error if the stream is destroyed
 */
const strace = (name_or_span, stream) => {
    let span;
    if (typeof name_or_span === 'string') {
        span = tracer.startSpan(name_or_span, {
            kind: opentelemetry.SpanKind.INTERNAL
        });
    }
    else {
        span = name_or_span;
    }
    let ended = false;
    function end() {
        if (ended) {
            return;
        }
        ended = true;
        span.end();
    }
    stream.once('error', (error) => {
        if (!ended) {
            (0, exports.logSpanError)(error, span);
        }
        end();
    });
    stream.once('end', end);
    stream.once('finish', end);
    stream.once('close', end);
    return stream;
};
exports.strace = strace;
